var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_vm._v("\n  © 2019 Sportsbook Agent Admin - Yong All Rights Reserved\n")])}
var staticRenderFns = []

export { render, staticRenderFns }